module.exports = __webpack_public_path__ + "media/images/mymp-logo-8016a1f451d4d91c95df785c2483c582.svg";